import PropTypes from 'prop-types';
import React from 'react';

const Complete = ({ size, ...props }) => (<svg
    width={size}
    height={(size / 0.9)}
    viewBox="0 0 18 20"
    {...props}
>
    <polygon
        points="9 0 18 5 18 15 9 20 0 15 0 5"
        fill="#3B863F"
    />
    <path
        d="M7.7 13.5l-0.6-0.8C6.6 12.1 5.8 11.2 5 10.5L5.9 9.4c0.5 0.4 1.1 1 1.6 1.5l0.1 0.1 0.1-0.1c1.1-1.4 3-3 4.6-4l0.7 1.3c-1.8 1.1-4 3.1-4.7 4.4L7.7 13.5z" // eslint-disable-line
        fill="#FFF"
    />
</svg>);

Complete.propTypes = {
    size: PropTypes.number,
};

Complete.defaultProps = {
    size: 18,
};

export default Complete;



// WEBPACK FOOTER //
// ./src/client/Components/Icons/Complete.js